<template>
  <v-app>
    <div class="grid-menu container w-100">
      <ImageLogo class="d-none d-lg-block" />
      <span class="text-right d-none d-lg-block pt-5">
        <Button :download-nick="nick" :software-title="soft" :text="page.download?.title" class="text-white" />
      </span>
    </div>
    <v-app-bar flat order="2">
      <v-row no-gutters class="align-center container mx-auto">
        <div class="v-col-2 d-lg-none d-flex justify-center">
          <v-btn id="menu-activator" icon="$menu" color="#FFF" class="burger" aria-label="menu" />
        </div>
        <v-col cols="6" md="7" lg="3" xl="2" class="d-flex justify-center d-lg-none d-flex">
          <ImageLogo />
        </v-col>

        <v-col cols="12" class="d-none d-lg-block">
          <Menu :menu="page.menu" class="d-flex font-weight-bold grid-menu" :nav="true" width="100%" />
        </v-col>

        <v-col cols="4" md="3" lg="2" xl="2" class="d-lg-none d-flex justify-center">
          <Button :download-nick="nick" :software-title="soft" :text="page.download?.title" class="text-white" />
        </v-col>
      </v-row>
    </v-app-bar>
    <v-menu activator="#menu-activator">
      <Menu :menu="page.menu" class="mt-4 font-weight-bold" />
    </v-menu>

    <v-main class="pt-0 container mx-auto">
      <breadcrumbs
        v-if="page.breadcrumbs && page.breadcrumbs.length > 0"
        :items="page.breadcrumbs"
        devider-icon="$chevronRight"
        devider-color="breadcrumbs"
        class="py-0 mt-2 ma-0"
      />

      <aside v-if="page.blocks?.AboveContent">
        <Region :key="page.uri" region="AboveContent" :blocks="page.blocks.AboveContent" />
      </aside>

      <v-row v-if="page.blocks?.RightSide" no-gutters>
        <v-col cols="12" md="9">
          <article class="pa-5">
            <Article :key="page.uri" class="pa-3"></Article>

            <Button
              :download-nick="nick"
              :software-title="soft"
              :text="page.download?.title"
              class="d-block ma-auto pa-2 my-6 text-uppercase font-weight-bold"
            />
          </article>
          <aside v-if="page.blocks?.BelowContent" class="blockDesign mr-2 mt-2 pa-5">
            <Region :key="page.uri" region="BelowContent" :blocks="page.blocks.BelowContent" />
          </aside>
        </v-col>

        <aside v-if="page.blocks?.RightSide" class="v-col-12 v-col-md-3">
          <Region
            :key="page.uri"
            region="RightSide"
            :blocks="page.blocks.RightSide"
            class="blockDesign rightBlock mb-2"
            @noregion="page.hideRegion"
          />
        </aside>
      </v-row>
      <template v-else>
        <article>
          <Article :key="page.uri" class="ma-2 pa-3"></Article>
          <Button
            :download-nick="nick"
            :software-title="soft"
            :text="page.download?.title"
            class="d-block ma-auto pa-2 my-6 text-uppercase font-weight-bold"
          />
        </article>
        <aside v-if="page.blocks?.BelowContent" class="blockDesign">
          <Region :key="page.uri" region="BelowContent" :blocks="page.blocks.BelowContent" />
        </aside>
      </template>
    </v-main>
    <footer v-if="page.blocks?.Footer" class="d-block">
      <Region :key="page.uri" region="Footer" :blocks="page.blocks.Footer" class="container ma-auto" />
    </footer>
    <ScrollToTop rounded="lg" />
  </v-app>
</template>
<script setup>
const page = inject("page");
const nick = ref(unref(page)?.rels?.downloadNick);
const soft = ref(unref(page)?.rels?.softwareTitle);

watchEffect(() => {
  nick.value = unref(page)?.rels?.downloadNick;
  soft.value = unref(page)?.rels?.softwareTitle;
});
const fab = ref(false);
</script>
